import { ELOQUA_PREPOP_SUCCESS } from "./eloqua-action-types";

const eloquaReducer = (state = false, action) => {
    if (action.type === ELOQUA_PREPOP_SUCCESS) {
        return true;
    }
    return state;
};

export default eloquaReducer;
